import React from "react";
import { useLocalStorage } from "../hooks/useLocalStorage";
import { useTimeAgo } from "../hooks/useTimeAgo";
import { Tooltip } from "./Tooltip";

export const DateTime = ({ date, tooltipPrefix }) => {
	const timeAgo = useTimeAgo(date);
	const [useLocalTime] = useLocalStorage("useLocalTime", false);

	const fullDate = useLocalTime
		? new Date(date).toLocaleString(undefined, {
				year: "numeric",
				month: "numeric",
				day: "numeric",
				hour: "numeric",
				minute: "2-digit",
				second: "2-digit",
				timeZoneName: "short",
			})
		: new Date(date).toUTCString();

	const tooltipContent = tooltipPrefix
		? `${tooltipPrefix}: ${fullDate}`
		: fullDate;

	return (
		<Tooltip content={tooltipContent}>
			<span className="whitespace-nowrap">{timeAgo}</span>
		</Tooltip>
	);
};
